// extracted by mini-css-extract-plugin
export var linkText = "_me-0";